import React from 'react';
import styles from '../styles.module.css';
import classNames from 'classnames';
import { ApplicationView, useController } from '@aha-app/mvc';
import WhiteboardController from '../controllers/WhiteboardController';

interface BaselineToolbarContainerProps {
  aiAssistantVisible?: boolean;
  children: React.ReactNode;
}

const BaselineToolbarContainer: React.FC<BaselineToolbarContainerProps> = ({
  children,
  aiAssistantVisible,
}) => {
  const controller = useController(WhiteboardController);
  const { sidePanelOpen } = controller.state;
  const { zendeskIconVisible } = controller.props;

  return (
    <div
      className={classNames(styles.baselineToolbarContainer, {
        [styles.zendeskIconVisible]: zendeskIconVisible,
        [styles.sidePanelOpen]: sidePanelOpen,
        [styles.aiAssistantVisible]: aiAssistantVisible,
      })}
    >
      {children}
    </div>
  );
};

export default ApplicationView(BaselineToolbarContainer);
